import React, { FC, useContext } from 'react';

import { FileManagerContext } from '../context';
import { FileManagerItemWrapperComponent } from './types';
import CustomIcon from 'components/base/CustomIcon';
import { OtherTypes } from 'components/base/CustomIcon/types';
import { formatFullDate } from 'utils/dateManager';

export const FileManagerItemWrapper: FC<FileManagerItemWrapperComponent> = (
  { value: folderItem },
) => {
  const { activeView } = useContext(FileManagerContext);

  return (
    <React.Fragment>
      <div className="icon">
        {folderItem.type === 'folder' && <CustomIcon icon={OtherTypes.FOLDER} />}
        {folderItem.type === 'file' && <CustomIcon icon={OtherTypes.FILE} />}
      </div>
      <div className="name">
        {folderItem.name}
      </div>
      {activeView === 'detail-view' && (
        <React.Fragment>
          <div className="mime-type">
            {folderItem.mimeTypeName || ''}
          </div>
          <div className="created-date">
            {`${folderItem.createdDate ? formatFullDate(folderItem.createdDate) : ''}`}
          </div>
          <div className="modified-date">
            {`${folderItem.modifiedDate ? formatFullDate(folderItem.modifiedDate) : ''}`}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
